
import React, { useState, useEffect } from "react";
const fetch = require("node-fetch");

export default function AddressSelect({ nextFormStep, prevFormStep, addresses, postcode, setLoading, loading, setWasteCollections, setD365Subs, setRouteCode  }) {

  const [addressId, setAddressId] = useState(-1);
  const [D365Down, setD365Down] = useState(false);
  const [ refuseCollectionError, setRefuseCollectionError] = useState(false);
  const [noItemSelectedError, setNoItemSelectedError] = useState(false);

  let D365DownAsyncCheck = false;

  function submitForm(){
    if(addressId < 0){
      setNoItemSelectedError(true);
    }
    else{
      let callback = function(){
          if(!refuseCollectionError && !D365DownAsyncCheck){
            nextFormStep();  
          }
        };
      retreiveBinDates(addressId, callback );
    }
  }



  /**
   * Retrieve GW subscriptions from Dynamics
   * 
   * PROD: https://prod-25.uksouth.logic.azure.com/workflows/f00fbf34211b472a8a4215a2029754f0/triggers/manual/paths/invoke/UPRN/${values.address.addressSelect}?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=a6JqKw91_LRQDWo-z1TnpblqGqhTzj2oFLlW0BvZ3gE
   * TEST: https://prod-16.uksouth.logic.azure.com/workflows/7453ad1d682c4cf393fc6b68dd0fdb76/triggers/manual/paths/invoke/UPRN/${values.address.addressSelect}?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=eAvqVq81fDjQlRtpEnT_AxhhQYLPt73g5Bq-Doc15ik
   *
   */
  async function retreiveBinDates(addressSelected, callback ){
    setLoading(true);

    const PROD = function(addressSelected){
      return `https://prod-25.uksouth.logic.azure.com/workflows/f00fbf34211b472a8a4215a2029754f0/triggers/manual/paths/invoke/UPRN/${addressSelected}?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=a6JqKw91_LRQDWo-z1TnpblqGqhTzj2oFLlW0BvZ3gE`;
    }
    const TEST = function(addressSelected){
      return `https://prod-16.uksouth.logic.azure.com/workflows/7453ad1d682c4cf393fc6b68dd0fdb76/triggers/manual/paths/invoke/UPRN/${addressSelected}?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=eAvqVq81fDjQlRtpEnT_AxhhQYLPt73g5Bq-Doc15ik`;
    }
    const subsUrl = PROD; //Use Prod Api by default, ENSURE SET TO PROD BEFORE DEPLOYMENT   
                          //only use TEST when testing on https://web-apps-asl-t.azurewebsites.net/

    let D365subs = 
      await fetch(subsUrl(addressSelected))
              .then((response) => {
                if(response.ok){
                  return response.json(); 
                } else {
                  /**D365 might be down as response ok is not in 2xx range, but the rest of the code should continue */
                  setD365Down(true);
                  D365DownAsyncCheck = true;
                  return response.json(); 
                }
              });

    let collectionSchedule = 
      await fetch(`https://webapps.southglos.gov.uk/Webservices/SGC.RefuseCollectionService/RefuseCollectionService.svc/getCollections/${addressSelected}`)
              .then((response) => {
                setLoading(false);
                if(response.ok){
                  return response.json(); 
                } else {
                  setRefuseCollectionError(true);
                  return response.json();
                }
              });
    
    setRouteCode(collectionSchedule[0]['CalendarName']);
    let collectionJson = generateGardenWasteCollectionJson(collectionSchedule, D365subs );  
    setWasteCollections(collectionJson);
    setD365Subs(D365subs);
    
    callback();
  }


  return (
    <div>
        <a className="" style={{"textDecoration" : "underline", "cursor" : "pointer"}}
          onClick={prevFormStep} >
          <svg style={{"transform" : "rotate(180deg)" }} xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'><g fill='none' fill-rule='evenodd'><path fill='#00709E' fill-rule='nonzero' d='M8.371 7l-4.527 4.244a.955.955 0 0 0 .002 1.413c.42.393 1.09.391 1.506.002l5.284-4.954a.962.962 0 0 0 .311-.704.96.96 0 0 0-.311-.706L5.352 1.34a1.116 1.116 0 0 0-1.506.002.953.953 0 0 0-.002 1.413L8.37 7z'/></g></svg>
          Back
        </a>
      &nbsp;
      <br/>
      <h2>Select your address</h2>
      <strong>{postcode}</strong>&nbsp;-&nbsp;
      <a style={{"textDecoration" : "underline", cursor : "pointer" }}  onClick={prevFormStep} >Change postcode</a>
      <br />
      <br />

      {refuseCollectionError &&
        <div className="validation-summary" role="alert">
          <h4>The form could not be submitted for the following reasons:</h4>
          <ul role="presentation">
            <li>We can't find collections that match '{postcode}'. There was a problem fetching the data</li>
            <li>Try again later.</li>
          </ul>
        </div>
      }

      {D365Down &&
        <div className="validation-summary" role="alert">
          <h4>The form could not be submitted for the following reasons:</h4>
          <ul role="presentation">
            <li>We cannot display all garden waste subscriptions at the moment.</li>
            <li>Try again later.</li>
          </ul>
        </div>
      }

      {noItemSelectedError &&
        <div className="validation-summary" role="alert">
          <h4>The form could not be submitted for the following reasons:</h4>
          <ul role="presentation">
            <li>Address is a required field</li>
          </ul>
        </div>
      }


      <select name="addressSelect" id="binLookerAddressSelect" aria-label="Address Select" onChange={(e) => setAddressId(e.target.value)}>
        <option value="">Select an address</option>
        {Object.entries(addresses).map(([key, value]) => {
          return <option value={value["uprn"]}>{value["address"]}</option>;
        })}
      </select>

      <br/>

      <button type="button" 
        className="button button--primary button__small"  
        disabled = {(loading == true) ? "disabled" : ""}
        onClick={submitForm} 
        style={{marginTop: 20 }}
        >Continue
      </button>
      <br/>
      <br/>
    </div>
  );
}




function generateGardenWasteCollectionJson(getCollectionScheduele, getD365Subs ){

  try{
    let gardenDates = false;
     if( getD365Subs.length > 0) {
      gardenDates = true;
    }
    
    let text;
    let collections = [];
    delete getCollectionScheduele[0]['CalendarName']

    for(let [key,value] of Object.entries(getCollectionScheduele[0])){
      if(key){
        if(key.indexOf("G") < 0){
          if(key.indexOf("R") >= 0){
            text = 'Recycling, food bin, black bin';
            if (gardenDates) text += ', garden waste';
          } else {
            text = 'Recycling, food bin';
          }

          let date    = new Date(value.split("/").reverse().join("-"));
          let days    = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
          let months  = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

          collections.push({
            date: date,
            date_display: days[date.getDay()] + " " + date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear(),
            text: text
          });
        }
      }
    }

    collections.sort(function(a,b){
      return new Date(a.date).getTime() - new Date(b.date).getTime()
    });
    return collections;
  }
  catch(e){
    console.log(e);
    return [];
  }
}